import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import RouteChunkFallback from 'routes/RouteChunkFallback';

const SuspenseOutlet = () => (
  <Suspense fallback={<RouteChunkFallback />}>
    <Outlet />
  </Suspense>
);

export default SuspenseOutlet;
